var $9bbe7d2a4b627f76$exports = {};
$9bbe7d2a4b627f76$exports = {
    "maximum": `M\xe1ximo`,
    "minimum": `M\xednimo`
};


export {$9bbe7d2a4b627f76$exports as default};
//# sourceMappingURL=es-ES.module.js.map
